const profile = {
    name: 'Name',
    avatar: 'Avatar',
    givenName: 'First name',
    familyName: 'Last name',
    middleName: 'Middle name',
    fullname: 'Full name',
    nickname: 'Nickname',
    preferredUsername: 'Preferred username',
    profile: 'Profile',
    website: 'Website',
    gender: 'Gender',
    birthdate: 'Birthdate',
    zoneinfo: 'Time zone',
    locale: 'Locale',
    address: {
        formatted: 'Address',
        streetAddress: 'Street address',
        locality: 'City',
        region: 'State/Province',
        postalCode: 'Zip code',
        country: 'Country',
    },
    gender_options: {
        female: 'Female',
        male: 'Male',
        prefer_not_to_say: 'Prefer not to say',
    },
};
export default Object.freeze(profile);
